<template>
    <v-container @keydown="CheckInvio()">
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('common.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-dialog persistent max-width="600" v-model="showDeleteAlert" :z-index="5000">
            <v-card>
                <v-card-title>{{ $t('manageSensors.sensorDeleting') }}</v-card-title>
                <v-card-text>
                    <h4>{{ $t('manageSensors.deleteConfirm', { name: nameDeleting }) }}</h4>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="showDeleteAlert = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="ConfirmDelete">{{ $t('common.ok') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAddBuilding" :z-index="5000">
            <v-card>
                <v-card-title>
                    {{ $t('building.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="buildingForm" v-model="isBuildingFormValid">
                        <v-text-field v-model="newBuildingName" :label="$t('building.fields.name')" outlined
                            color="#213A8F" maxlength="50" counter :rules="[rules.required]" />
                        <v-text-field v-model="newBuildingAddress" :label="$t('building.fields.address')" outlined
                            color="#213A8F" maxlength="50" counter :rules="[rules.required]" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAddBuilding = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateBuilding">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAddFloor" :z-index="5000">
            <v-card>
                <v-card-title>
                    {{ $t('floor.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="floorForm" v-model="isFloorFormValid">
                        <v-select v-model="buildingValue" color="#213A8F" outlined :items="buildings"
                            :label="$t('floor.fields.building')" prepend-inner-icon="mdi-home"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            v-if="showBuilding" :disabled="true" :rules="[rules.required]"
                            :no-data-text="$t('common.noDataAvailable')" />
                        <v-text-field v-model="newFloorName" :label="$t('floor.fields.name')" outlined color="#213A8F"
                            maxlength="50" counter :rules="[rules.required]" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAddFloor = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateFloor">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAddArea" :z-index="5000">
            <v-card>
                <v-card-title>
                    {{ $t('area.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="areaForm" v-model="isAreaFormValid">
                        <v-select v-model="buildingValue" color="#213A8F" outlined :items="buildings"
                            :label="$t('area.fields.building')" prepend-inner-icon="mdi-home"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            v-if="showBuilding" :disabled="true" :rules="[rules.required]"
                            :no-data-text="$t('common.noDataAvailable')" />
                        <v-select v-model="floorValue" color="#213A8F" outlined :items="floors"
                            :label="$t('area.fields.floor')" prepend-inner-icon="mdi-floor-plan"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F" :key="f"
                            v-if="showFloor" :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />
                        <v-text-field v-model="newAreaName" :label="$t('area.fields.name')" outlined color="#213A8F"
                            maxlength="50" counter :rules="[rules.required]" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAddArea = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateArea">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAdd" :z-index="1000">
            <v-card>
                <v-card-title>
                    {{ isDuplicating ? $t('sensor.duplicate.title') : $t('sensor.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="form" v-model="isFormValid">
                        <v-text-field v-model="devEui" :label="$t('sensor.fields.sensorId')" outlined color="#213A8F"
                            maxlength="50" counter :rules="[rules.required, rules.uniqueDevEui]" />

                        <v-text-field v-model="dispenserName" :label="$t('sensor.fields.dispenserName')" outlined
                            color="#213A8F" maxlength="20" counter :rules="[rules.required]" />

                        <!-- Selezione tipo per sensori Button -->
                        <v-select v-if="isButtonPage"
                            v-model="buttonSubtype"
                            color="#213A8F" outlined
                            :items="buttonSubtypeOptions"
                            :label="$t('sensor.fields.buttonType')"
                            prepend-inner-icon="mdi-gesture-tap-button"
                            append-icon="mdi-arrow-down-drop-circle-outline"
                            :rules="[rules.required]"
                            :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-if="!isButtonPage" v-model="dispenserBrand" color="#213A8F" outlined :items="dispenserBrands"
                            :label="$t('sensor.fields.dispenserBrand')" prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-if="!isButtonPage && showDispenserArticleCode" v-model="dispenserArticleCode" color="#213A8F"
                            outlined :items="dispenserArticleCodes" :label="$t('sensor.fields.dispenserArticleCode')"
                            item-text="text" item-value="value"
                            prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-if="!isButtonPage && showConsumableBrand" v-model="consumableBrand" color="#213A8F" outlined
                            :items="consumableBrands" :label="$t('sensor.fields.consumableBrand')"
                            prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-if="!isButtonPage && showConsumableArticleCode" v-model="consumableArticleCode" color="#213A8F"
                            outlined :items="consumableArticleCodes" :label="$t('sensor.fields.consumableArticleCode')"
                            prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-model="client" color="#213A8F" outlined :items="clients"
                            :label="$t('sensor.fields.client')" prepend-inner-icon="mdi-account"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-layout>
                            <v-flex class="xs-11 md-11 sm-11" :style="isButtonPage ? 'flex: 0 0 100%; max-width: 100%;' : ''">
                                <v-select v-if="showBuilding" v-model="buildingValue" color="#213A8F" outlined
                                    :items="buildings" :label="$t('sensor.fields.building')"
                                    prepend-inner-icon="mdi-home" append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" :rules="[rules.required]"
                                    :no-data-text="$t('common.noDataAvailable')" />
                            </v-flex>
                            <v-flex xs-1 md-1 sm-1>
                                <v-icon v-if="showBuilding && !isButtonPage" class="mt-4 mb-4" color="#213A8F" text
                                    @click="CreateNewBuilding()">mdi-plus-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex class="xs-11 md-11 sm-11" :style="isButtonPage ? 'flex: 0 0 100%; max-width: 100%;' : ''">
                                <v-select v-if="showFloor" v-model="floorValue" color="#213A8F" outlined :items="floors"
                                    :label="$t('sensor.fields.floor')" prepend-inner-icon="mdi-floor-plan"
                                    append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                                    :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />
                            </v-flex>
                            <v-flex xs-1 md-1 sm-1>
                                <v-icon v-if="showFloor && !isButtonPage" class="mt-4 mb-4" color="#213A8F" text
                                    @click="CreateNewFloor()">mdi-plus-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex class="xs-11 md-11 sm-11" :style="isButtonPage ? 'flex: 0 0 100%; max-width: 100%;' : ''">
                                <v-select v-if="showArea" v-model="areaValue" color="#213A8F" outlined :items="areas"
                                    :label="$t('sensor.fields.area')" prepend-inner-icon="mdi-texture-box"
                                    append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                                    :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />
                            </v-flex>
                            <v-flex xs-1 md-1 sm-1>
                                <v-icon v-if="showArea && !isButtonPage" class="mt-4 mb-4" color="#213A8F" text
                                    @click="CreateNewArea()">mdi-plus-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="closeAddDialog">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateSensor">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-card class="mt-4 mb-4">
                <v-layout id="makeMeBlue">
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select v-model="filterClient" color="#213A8F" outlined :items="filterClients" :label="$t('manageSensors.client')"
                            prepend-inner-icon="mdi-account" append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" :no-data-text="$t('manageSensors.noDataAvailable')" />
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select prepend-inner-icon="mdi-home" v-model="filterBuilding" :items="filterBuildings"
                            :label="$t('manageSensors.building')" outlined append-icon="mdi-arrow-down-drop-circle-outline"
                            :no-data-text="$t('manageSensors.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select prepend-inner-icon="mdi-floor-plan" class="ml-2"
                            append-icon="mdi-arrow-down-drop-circle-outline" v-model="filterFloor" :items="filterFloors"
                            :label="$t('manageSensors.floor')" outlined :no-data-text="$t('manageSensors.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select v-model="filterArea" color="#213A8F" outlined :items="filterAreas" :label="$t('manageSensors.area')"
                            prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" :no-data-text="$t('manageSensors.noDataAvailable')" />
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select v-model="filterSensor" prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" :items="filterSensors" :label="$t('manageSensors.sensor')"
                            outlined :no-data-text="$t('manageSensors.noDataAvailable')">
                        </v-select>
                    </v-flex>
                </v-layout>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="ClearFilter">
                    <span style="color: #213A8F;">{{ $t('manageSensors.clearFilter') }}</span>
                    <v-icon color="#213A8F" left>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            </v-card>
            <div v-if="addButton && ($route.params.type === 'dispenser' || isButtonPage)" class="mt-4 mb-4 ml-4">
                <v-btn color="#213A8F" dark @click="CreateNew()" elevation="2">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    {{ $t('manageSensors.addNewSensor') }}
                </v-btn>
            </div>
            <v-card>
                <!-- <v-card-actions class="mb-0">
                    <v-spacer></v-spacer>
                    <v-layout>
                        <v-flex xs3 sm3 md3>
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                outlined></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-actions> -->
                <v-card-text class="mt-0">
                    <v-data-table v-bind:headers="filteredHeaders" :items="items" :hide-default-footer="true"
                        disable-pagination class="elevation-1" :search="search" :no-data-text="$t('common.noDevicesConnected')">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>
                                    <v-icon 
                                        :color="$route.params.type === 'washroom' ? item.cleaningStatusColor : (['air'].includes($route.params.type) || isButtonPage ? 'green' : item.stato)"
                                        size="20">
                                        mdi-circle
                                    </v-icon>
                                </td>
                                <td>
                                    <!-- Per i button mostra il tipo tradotto invece dell'immagine -->
                                    <span v-if="isButtonPage && item.dispenserSubtype">
                                        {{ $t('manageSensors.buttonSubtypes.' + item.dispenserSubtype) || item.dispenserSubtype }}
                                    </span>
                                    <!-- Per gli altri tipi mostra l'immagine -->
                                    <img v-else class="mt-2 mr-4 align-center" style="width: 50px; align-content:center"
                                        :src="item.DispenserType"
                                        @error="handleImageError($event, item)"
                                        :alt="item.name" />
                                </td>
                                <!-- Colonna Fill Level per dispenser -->
                                <td v-if="$route.params.type === 'dispenser'">{{ item.status == 'on' && item.percentuale
                                    > -1 ? (item.percentuale + '%') : '' }}
                                </td>
                                <!-- Colonna Live Usage per washroom -->
                                <td v-if="$route.params.type === 'washroom'">
                                    {{ item.liveUsage }}
                                </td>
                                <!-- Colonna Cleaning Limit per washroom -->
                                <td v-if="$route.params.type === 'washroom'">
                                    {{ item.cleaningLimit }}
                                </td>
                                <td>
                                    <a v-if="$route.params.type === 'dispenser'" @click="navigateToSmartDispenser(item)"
                                        style="color: #213A8F; cursor: pointer; text-decoration: underline;">
                                        {{ item.name }}
                                    </a>
                                    <a v-else-if="$route.params.type === 'washroom'"
                                        @click="navigateToSmartCleaning(item)"
                                        style="color: #213A8F; cursor: pointer; text-decoration: underline;">
                                        {{ item.name }}
                                    </a>
                                    <a v-else-if="$route.params.type === 'air'"
                                        @click="navigateToAirQuality(item)"
                                        style="color: #213A8F; cursor: pointer; text-decoration: underline;">
                                        {{ item.name }}
                                    </a>
                                    <span v-else>{{ item.name }}</span>
                                </td>
                                <td>{{ item.Company }}</td>
                                <td>{{ item.BuildingName }}</td>
                                <td>{{ item.floor }}</td>
                                <td>{{ item.Area }}</td>
                                <td v-if="item.battery > 0">{{ item.battery }}%</td>
                                <td v-else></td>
                                <td>{{ item.sensorId }}</td>
                                <td>
                                    <v-tooltip v-if="$route.params.type === 'dispenser' || isButtonPage" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon color="#213A8F" text class="mr-2"
                                                @click="editSensor(item)"
                                                v-bind="attrs"
                                                v-on="on">mdi-pencil</v-icon>
                                        </template>
                                        <span>{{ $t('manageSensors.tooltips.edit') }}</span>
                                    </v-tooltip>
                                    
                                    <v-tooltip v-if="$route.params.type === 'dispenser'" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon color="#213A8F" text class="mr-2"
                                                @click="duplicateSensor(item)"
                                                v-bind="attrs"
                                                v-on="on">mdi-content-copy</v-icon>
                                        </template>
                                        <span>{{ $t('manageSensors.tooltips.duplicate') }}</span>
                                    </v-tooltip>
                                    
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon color="#213A8F" text
                                                @click="AlertDeleting(item.id, item.name)"
                                                v-bind="attrs"
                                                v-on="on">mdi-delete</v-icon>
                                        </template>
                                        <span>{{ $t('manageSensors.tooltips.delete') }}</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-card>
        <v-dialog persistent max-width="600" v-model="dialogEdit" :z-index="1000">
            <v-card>
                <v-card-title>
                    {{ $t('manageSensors.editSensor') }} : {{ editingSensorName }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-text-field :label="$t('sensor.fields.sensorId')" v-model="devEui" outlined color="#213A8F" maxlength="50" counter
                        :disabled="true" />
                    <v-text-field :label="$t('sensor.fields.dispenserName')" v-model="dispenserName" outlined color="#213A8F" maxlength="20"
                        counter />
                    <!-- Selezione tipo per sensori Button — disabilitata in modifica -->
                    <v-select v-if="isButtonPage"
                        v-model="buttonSubtype"
                        color="#213A8F" outlined
                        :items="buttonSubtypeOptions"
                        :label="$t('sensor.fields.buttonType')"
                        prepend-inner-icon="mdi-gesture-tap-button"
                        append-icon="mdi-arrow-down-drop-circle-outline"
                        :disabled="true"
                        :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-if="!isButtonPage" v-model="dispenserBrand" color="#213A8F" outlined :items="dispenserBrands"
                        :label="$t('sensor.fields.dispenserBrand')" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="dispenserArticleCode" color="#213A8F" outlined :items="dispenserArticleCodes"
                        :label="$t('sensor.fields.dispenserArticleCode')" item-text="text" item-value="value"
                        prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        v-if="!isButtonPage && showDispenserArticleCode" :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="consumableBrand" color="#213A8F" outlined :items="consumableBrands"
                        :label="$t('sensor.fields.consumableBrand')" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        v-if="!isButtonPage && showConsumableBrand" :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="consumableArticleCode" color="#213A8F" outlined :items="consumableArticleCodes"
                        :label="$t('sensor.fields.consumableArticleCode')" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        v-if="!isButtonPage && showConsumableArticleCode" :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="client" color="#213A8F" outlined :items="clients" :label="$t('sensor.fields.client')"
                        prepend-inner-icon="mdi-account" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                    <v-layout>
                        <v-flex class="xs-11 md-11 sm-11" :style="isButtonPage ? 'flex: 0 0 100%; max-width: 100%;' : ''">
                            <v-select v-model="buildingValue" color="#213A8F" outlined :items="buildings"
                                :label="$t('sensor.fields.building')" prepend-inner-icon="mdi-home"
                                append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                                v-if="showBuilding" :no-data-text="$t('common.noDataAvailable')" />
                        </v-flex>
                        <v-flex xs-1 md-1 sm-1>
                            <v-icon v-if="showBuilding && !isButtonPage" class="mt-4 mb-4" color="#213A8F" text
                                @click="CreateNewBuilding()">mdi-plus-circle-outline</v-icon></v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex class="xs-11 md-11 sm-11" :style="isButtonPage ? 'flex: 0 0 100%; max-width: 100%;' : ''">
                            <v-select v-model="floorValue" color="#213A8F" outlined :items="floors" :label="$t('sensor.fields.floor')"
                                prepend-inner-icon="mdi-floor-plan" append-icon="mdi-arrow-down-drop-circle-outline"
                                append-icon-color="#213A8F" :key="f" v-if="showFloor"
                                :no-data-text="$t('common.noDataAvailable')" />
                        </v-flex>
                        <v-flex xs-1 md-1 sm-1>
                            <v-icon v-if="showFloor && !isButtonPage" class="mt-4 mb-4" color="#213A8F" text
                                @click="CreateNewFloor()">mdi-plus-circle-outline</v-icon></v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex class="xs-11 md-11 sm-11" :style="isButtonPage ? 'flex: 0 0 100%; max-width: 100%;' : ''">
                            <v-select v-model="areaValue" color="#213A8F" outlined :items="areas" :label="$t('sensor.fields.area')"
                                prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                                append-icon-color="#213A8F" :key="a" v-if="showArea" :no-data-text="$t('common.noDataAvailable')" />
                        </v-flex>
                        <v-flex xs-1 md-1 sm-1>
                            <v-icon v-if="showArea && !isButtonPage" class="mt-4 mb-4" color="#213A8F" text
                                @click="CreateNewArea()">mdi-plus-circle-outline</v-icon></v-flex>
                    </v-layout>
                    <v-text-field v-if="sheetsVisible" outlined v-model="maxPaper"
                        :label="$t('sensor.fields.maxSheets')"></v-text-field>
                    
                    <v-text-field v-if="!isButtonPage" outlined v-model="maxValue" color="#213A8F"
                        :label="$t('sensor.fields.maxValue')" type="number"></v-text-field>
                    
                    <v-text-field v-if="!isButtonPage" outlined v-model="minValue" color="#213A8F"
                        :label="$t('sensor.fields.minValue')" type="number"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="UpdateSensor">{{ $t('manageSensors.update') }}</v-btn>
                    <v-btn text color="#213A8F" @click="closeEditDialog">{{ $t('common.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="errorDialog" max-width="400">
            <v-card>
                <v-card-title class="headline">
                    {{ $t('sensor.error.title') }}
                </v-card-title>
                <v-card-text>
                    {{ errorMessage }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#213A8F" text @click="errorDialog = false">
                        {{ $t('common.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog for duplicate sensor error -->
        <v-dialog v-model="duplicateSensorDialog" max-width="500" persistent>
            <v-card>
                <v-card-title class="headline">
                    {{ $t('sensor.error.title') }}
                </v-card-title>
                <v-card-text>
                    <p>{{ $t('sensor.error.duplicateDevEui') }}</p>
                    <p class="mt-2" style="color: #666; font-size: 14px;">
                        {{ $t('sensor.error.duplicateDevEuiHint') || 'Il Sensor ID inserito è già associato ad un altro sensore. Inserire un ID univoco.' }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#213A8F" text @click="handleDuplicateSensorError">
                        {{ $t('common.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import axios from "axios";
import { applyDoorCountFloor } from "@/utils/sensorUtils";
export default {
    data() {
        return {
            isDuplicating: false,
            isLoadingEditData: false,
            id_deleting: 0,
            dialogAddArea: false,
            newAreaName: '',
            newBuildingAddress: '',
            nameDeleting: '',
            showDeleteAlert: false,
            search: '',
            filterClient: '',
            filterClients: [],
            filterBuilding: '',
            filterBuildings: [],
            filterFloor: '',
            filterFloors: [],
            filterArea: '',
            filterAreas: [],
            filterSensor: '',
            filterSensors: [],
            newBuildingName: '',
            newFloorName: '',
            dialogAddFloor: false,
            dialogAddBuilding: false,
            consumableArticleCodes: [],
            showConsumableArticleCode: false,
            consumableBrands: [],
            showConsumableBrand: false,
            dispenserArticleCodes: [],
            showDispenserArticleCode: false,
            showArea: false,
            areas: [],
            showFloor: false,
            floors: [],
            showBuilding: false,
            buildings: [],
            clients: [],
            dispenserBrands: [],
            areaValue: '',
            devEui: '',
            dispenserName: '',
            dispenserBrand: '',
            dispenserArticleCode: '',
            consumableBrand: '',
            consumableArticleCode: '',
            client: '',
            filterBuildingValue: "ALL",
            filterBuilding_items: [],
            building_items: [],
            addButton: true,
            f: 0,
            b: 0,
            floor_items: [],
            floorValue: "",
            buildingValue: [],
            sensorTypes: [],
            Tipologiasensore: '',
            deveui: '',
            sheetsVisible: false,
            maxPaper: 0,
            maxValue: '',
            minValue: '',
            overlay: true,
            dialogAdd: false,
            items: [],
            items_all: [],
            dialogEdit: false,
            editingSensorId: null,
            editingSensorName: '',
            errorDialog: false,
            errorMessage: '',
            isFormValid: false,
            duplicateSensorDialog: false,
            buttonSubtype: '',
            rules: {
                required: v => !!v || this.$t('validation.required') || 'This field is required',
                uniqueDevEui: async v => {
                    // Non eseguire la validazione se il dialog di aggiunta non è aperto
                    if (!this.dialogAdd) return true;
                    
                    if (!v) return true; // Skip if empty (handled by required)
                    try {
                        const response = await axios.post(this.$store.state.URL_CHECK_SENSOR_EXISTS, {
                            devEui: v
                        });
                        if (response.data.exists) {
                            // NON mostrare il dialog qui, solo invalidare il campo
                            // Il dialog verrà mostrato dal controllo finale in CreateSensor()
                            return this.$t('validation.duplicateDevEui') || 'This Sensor ID already exists';
                        }
                        return true;
                    } catch (error) {
                        console.error('Error checking sensor existence:', error);
                        return this.$t('sensor.error.checkingExistence') || 'Error checking sensor';
                    }
                }
            }
        }
    },
    created() {
        this.items = [];
        axios
            .post(`${this.$store.state.URL_SENSORSMANAGEMENT}`,
                { id_company: this.$store.state.company, 'type': this.$route.params.type })
                .then(async res => {
                    // Mappa base dei sensori
                    const baseItems = res.data.map(el => {
                        // Identifica il tipo di sensore (DispenserSubtype)
                        const sensorSubtype = el.DispenserSubtype || null;
                        
                        // Calcola dati washroom se presenti, applicando aggiustamento Door Counter
                        const rawPartialCount = Number(el.PartialCount) || 0;
                        const partialCount = this.applyDoorCounterAdjustment(rawPartialCount, sensorSubtype);
                        const rawAlertValue = Number(el.AlertValue) || 0;
                        const alertValue = this.applyDoorCounterAdjustment(rawAlertValue, sensorSubtype);
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        let cleaningStatusColor = 'gray';
                        let cleaningStatus = '';
                        
                        if (el.DispenserType === 'Washroom' && alertValue > 0) {
                            if (perc >= 100) {
                                cleaningStatusColor = "red";
                                cleaningStatus = "Cleaning Required";
                            } else if (perc > 25) {
                                cleaningStatusColor = "#ffac27";
                                cleaningStatus = "Might need clean";
                            } else {
                                cleaningStatusColor = "green";
                                cleaningStatus = "Doesn't need clean";
                            }
                        }
                        
                        // Off/online da percentuale = -1 (senza chiamata GET_DATA_FROM_DYNAMO)
                        const isOffByPercent = Number(el.percentuale) === -1;
                        
                        // Per i dispenser, usa la soglia di alert (AlertValue)
                        const dispenserAlertThreshold = Number(el.AlertValue) || 0;
                        
                        // Per i sensori Air e Washroom, costruisci l'URL completo da S3
                        let dispenserImage = el.DispenserImage;
                        if (el.DispenserType === 'Air' || el.DispenserType === 'Washroom') {
                            console.log('Air/Washroom sensor detected:', {
                                sensorName: el.DisplayName,
                                dispenserImage: el.DispenserImage,
                                dispenserType: el.DispenserType
                            });
                            
                            if (el.DispenserImage) {
                                // Verifica se DispenserImage è già un URL completo o solo il nome del file
                                if (!el.DispenserImage.startsWith('http')) {
                                    dispenserImage = this.$store.state.URL_IMAGES_S3 + el.DispenserImage;
                                    console.log('✅ Constructed S3 URL:', dispenserImage);
                                } else {
                                    console.log('✅ Image is already a full URL:', dispenserImage);
                                }
                            } else {
                                console.warn('⚠️ DispenserImage is empty for sensor:', el.DisplayName);
                            }
                        }
                        
                        const mappedItem = {
                            stato: isOffByPercent && el.DispenserType == 'Dispenser' ? 'gray' : (el.DispenserType == 'Dispenser' ? this.calculateDispenserStatus(el.percentuale, dispenserAlertThreshold) : ''),
                            DispenserType: dispenserImage,
                            percentuale: el.DispenserType == 'Dispenser' ? el.percentuale : '',
                            name: el.DisplayName,
                            Company: el.CompanyName,
                            BuildingName: el.BuildingName,
                            floor: el.FloorName,
                            status: isOffByPercent ? 'off' : (el.DispenserType == 'Dispenser' || (el.DispenserType === 'Washroom' && alertValue > 0) ? 'on' : 'off'),
                            battery: el.BatteryLevel,
                            Area: el.AreaName,
                            sensorId: el.DispenserUnique,
                            id: el.id,
                            liveUsage: partialCount,
                            cleaningLimit: alertValue > 0 ? alertValue : '-',
                            cleaningStatus: cleaningStatus,
                            cleaningStatusColor: isOffByPercent && el.DispenserType === 'Washroom' ? 'gray' : cleaningStatusColor,
                            sensorSubtype: sensorSubtype, // Salva il tipo di sensore per uso successivo
                            dispenserSubtype: sensorSubtype, // Anche come dispenserSubtype per la visualizzazione
                            // Aggiungi gli ID necessari per la navigazione
                            companyId: el.CompanyId,
                            buildingId: el.BuildingId,
                            floorId: el.FloorId,
                            areaId: el.AreaId
                        };
                        
                        // Log per verificare che l'URL sia assegnato correttamente
                        if (el.DispenserType === 'Air' || el.DispenserType === 'Washroom') {
                            console.log('📦 Final mapped item for Air/Washroom sensor:', {
                                name: mappedItem.name,
                                DispenserType: mappedItem.DispenserType,
                                imageLength: mappedItem.DispenserType ? mappedItem.DispenserType.length : 0
                            });
                        }
                        
                        return mappedItem;
                    });

                    this.items = baseItems;
                    this.items_all = this.items;
                    this.filterBuilding_items = this.items.map(item => ({
                        text: item.BuildingName,
                        value: item.BuildingName
                    }));
                    this.filterBuilding_items.push({ text: "ALL", value: "ALL" });

                    this.DownloadCompanyDatas();
                    this.GetDispenserTypes();
                    this.overlay = false;
                })
                .catch(error => {
                    console.error('Error fetching sensor data:', error);
                    this.overlay = false; // Ensure overlay is removed even if there's an error
                });
    },
    methods: {
        // Helper method per applicare l'aggiustamento Door Counter
        applyDoorCounterAdjustment(value, sensorSubtype) {
            // Per sensori Door Count: tutti i dati con decimali approssimati per difetto (senza dimezzare)
            return applyDoorCountFloor(value, sensorSubtype, { divideBy2: false });
        },
        
        calculateDispenserStatus(percentuale, alertThreshold) {
            // Se non c'è dato, grigio
            if (percentuale === -1 || percentuale === null || percentuale === undefined) {
                return "gray";
            }
            
            // Se non c'è soglia di alert impostata, usa i valori di default
            if (alertThreshold === null || alertThreshold === undefined || alertThreshold === 0) {
                // Valori di default: rosso < 15%, arancione < 40%, verde >= 40%
                if (percentuale < 15) return "red";
                if (percentuale < 40) return "orange";
                return "green";
            }
            
            // Nuovo criterio basato sulla soglia di alert
            // Rosso: minore o uguale alla soglia di alert
            if (percentuale <= alertThreshold) {
                return "red";
            }
            
            // Arancione: dalla soglia di alert fino a (soglia + 30%)
            if (percentuale <= alertThreshold + 30) {
                return "orange";
            }
            
            // Verde: tutto quello che c'è sopra
            return "green";
        },
        async loadWashroomData(items) {
            // Carica i dati di utilizzo e soglia per ogni sensore washroom
            const promises = items.map(async item => {
                try {
                    const response = await axios.post(this.$store.state.URL_LASTMANAGED, {
                        sensor: item.id
                    });
                    
                    if (response.data && response.data.length > 0) {
                        const data = response.data[0];
                        // Applica l'aggiustamento Door Counter
                        const rawAlertValue = Number(data.AlertValue) || 0;
                        const alertValue = this.applyDoorCounterAdjustment(rawAlertValue, item.sensorSubtype || item.dispenserSubtype);
                        const rawPartialCount = Number(data.PartialCount) || 0;
                        const partialCount = this.applyDoorCounterAdjustment(rawPartialCount, item.sensorSubtype || item.dispenserSubtype);
                        
                        // Calcola la percentuale di utilizzo con i valori aggiustati
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        // Imposta il colore del pallino in base alla percentuale
                        if (perc >= 100) {
                            item.cleaningStatusColor = "red";
                            item.cleaningStatus = "Cleaning Required";
                        } else if (perc > 25) {
                            item.cleaningStatusColor = "#ffac27";
                            item.cleaningStatus = "Might need clean";
                        } else {
                            item.cleaningStatusColor = "green";
                            item.cleaningStatus = "Doesn't need clean";
                        }
                        
                        // Imposta Live Usage e Cleaning Limit
                        item.liveUsage = partialCount;
                        item.cleaningLimit = alertValue > 0 ? alertValue : '-';
                    } else {
                        // Nessun dato disponibile, sensore offline
                        item.status = 'off';
                        item.cleaningStatusColor = 'gray';
                    }
                } catch (error) {
                    console.error(`Error loading washroom data for sensor ${item.id}:`, error);
                    item.status = 'off';
                    item.cleaningStatusColor = 'gray';
                }
            });
            
            await Promise.all(promises);
        },
        CreateBuilding() {
            // Valida il form e mostra eventuali errori
            if (!this.$refs.buildingForm.validate()) {
                return;
            }
            
            axios
                .post(`${this.$store.state.URL_CREATE_BUILDING}`,
                    { buildingName: this.newBuildingName, 'address': this.newBuildingAddress, 'companyId': this.client })
                .then(() => {
                    axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                        companyId: this.client
                    })
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.BuildingName, value: el.id }
                                this.buildings.push(element);

                            });
                            this.dialogAddBuilding = false;
                        })

                })
        },
        CreateFloor() {
            // Valida il form e mostra eventuali errori
            if (!this.$refs.floorForm.validate()) {
                return;
            }
            
            axios
                .post(`${this.$store.state.URL_CREATE_FLOOR}`,
                    { floorName: this.newFloorName, buildingId: this.buildingValue })
                .then(() => {
                    axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                        buildingId: this.buildingValue
                    })
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.FloorName, value: el.id }
                                this.floors.push(element);

                            });
                            this.dialogAddFloor = false;
                        })

                })

        },
        CreateArea() {
            // Valida il form e mostra eventuali errori
            if (!this.$refs.areaForm.validate()) {
                return;
            }
            
            axios
                .post(`${this.$store.state.URL_CREATE_AREA}`,
                    { areaName: this.newAreaName, floorId: this.floorValue })
                .then(() => {
                    axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                        floorId: this.floorValue
                    })
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.AreaName, value: el.id }
                                this.areas.push(element);

                            });
                            this.dialogAddArea = false;
                        })

                })
        },
        CreateNewArea() {
            this.dialogAddArea = true;
        },
        AlertDeleting(_id, _name) {
            this.id_deleting = _id;
            this.nameDeleting = _name;
            this.showDeleteAlert = true;

        },
        ConfirmDelete() {
            axios
                .post(`${this.$store.state.URL_DELETE_SENSOR}`, {
                    id: this.id_deleting
                })
                .then(() => {
                    this.showDeleteAlert = false;
                    this.Filter();
                })
        },
        async CreateSensor() {
            // Prima di tutto, valida il form e mostra eventuali errori
            if (!this.$refs.form.validate()) {
                // Il form non è valido, i campi con errori verranno evidenziati in rosso automaticamente
                return;
            }
            
            // Controllo finale: verifica che il devEui non esista già
            try {
                this.overlay = true;
                const checkResponse = await axios.post(this.$store.state.URL_CHECK_SENSOR_EXISTS, {
                    devEui: this.devEui.toUpperCase()
                });
                
                if (checkResponse.data.exists) {
                    this.overlay = false;
                    this.duplicateSensorDialog = true;
                    return; // Blocca l'inserimento
                }
            } catch (error) {
                console.error('Error checking sensor existence:', error);
                this.overlay = false;
                this.showError(this.$t('sensor.error.checkingExistence') || 'Errore durante la verifica del sensore');
                return;
            }

            // Se il controllo passa, procedi con l'inserimento
            const isButton = this.isButtonPage;
            const createPayload = {
                dispenserArticleCodeId: isButton ? '-' : this.dispenserArticleCode,
                brandId: isButton ? '-' : this.dispenserBrand,
                companyId: this.client,
                sensorName: this.dispenserName,
                floorId: this.floorValue,
                devEui: this.devEui.toUpperCase(),
                dispenserModelId: isButton ? '-' : this.dispenserArticleCode,
                dispenserBrandId: isButton ? '-' : this.dispenserBrand,
                idArea: this.areaValue,
                idConsumableBrand: isButton ? '-' : this.consumableBrand,
                idConsumableArticleCode: isButton ? '-' : this.consumableArticleCode,
                idBuilding: this.buildingValue,
                dispenserSubtype: isButton
                    ? (this.buttonSubtype === 'RFID_BUTTON' ? 'RFID' : this.buttonSubtype)
                    : this.selectedDispenserSubtype,
                sensorType: isButton
                    ? (this.buttonSubtype === 'RFID_BUTTON' ? 'RFID_BUTTON' : 'button')
                    : undefined,
            };
            axios
                .post(`${this.$store.state.URL_CREATE_NEW_SENSOR}`, createPayload)
                .then(res => {
                    console.log(res.data.message)
                    if (res.data.message === "Sensor created successfully") {
                        this.overlay = false;
                        this.closeAddDialog(); // Usa il nuovo metodo per chiudere e resettare
                        this.Filter();
                    } else {
                        this.overlay = false;
                    }
                })
                .catch(error => {
                    console.error('Error creating sensor:', error);
                    this.overlay = false;
                    this.showError(this.$t('sensor.error.creating') || 'Errore durante la creazione del sensore');
                });
        },
        CreateNewBuilding() {
            this.dialogAddBuilding = true;
            this.newBuildingAddress = '';
            this.newBuildingName = '';
        },
        CreateNewFloor() {
            this.dialogAddFloor = true;
            this.newFloorName = '';
        },
        CreateNew() {
            this.isDuplicating = false; // Reimposta flag per creazione normale
            this.floors.length = 0;
            this.areas.length = 0;
            this.sheetsVisible = false;
            this.Tipologiasensore = '';
            this.buildingValue = '';
            this.floorValue = '';
            this.maxPaper = 0;
            this.maxValue = '';
            this.minValue = '';
            this.areaValue = '';
            this.devEui = '';
            this.dispenserName = '';
            this.dispenserBrand = '';
            this.dispenserArticleCode = '';
            this.consumableBrand = '';
            this.consumableArticleCode = '';
            this.client = '';
            this.buildingValue = '';
            this.buttonSubtype = '';
            this.overlay = true;
            this.showDispenserArticleCode = false;
            this.showArea = false;
            this.showFloor = false;
            this.showBuilding = false;
            this.consumableBrands.length = 0;
            this.showConsumableBrand = false;
            this.showConsumableArticleCode = false;

            // Reset della validazione del form
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }
            });

            this.LoadComponentData();
        },
        ClearFilter() {
            this.filterClient = '';
            this.filterBuildings.length = 0;
            this.filterBuilding = '';
            this.filterFloor = '';
            this.filterFloors.length = 0;
            this.filterArea = '';
            this.filterAreas.length = 0;
            this.filterSensors.length = 0;
            this.filterSensor = '';
            this.filterBuildings = [];
            this.filterFloors = [];
            this.filterAreas = [];
            this.filterSensors = [];
            this.Filter();
        },
        async Filter(skipOverlay = false) {
            if (!skipOverlay) {
                this.overlay = true;
            }
            return axios
                .post(`${this.$store.state.URL_SENSORSMANAGEMENT}`,
                    {
                        id_company: this.$store.state.company,
                        'type': this.$route.params.type,
                        "companyId": this.$store.state.company,
                        "clientId": this.filterClient,
                        "buildingId": this.filterBuilding,
                        "floorId": this.filterFloor,
                        "areaId": this.filterArea,
                        "sensorId": this.filterSensor
                    })

                .then(async res => {
                    const baseItems = res.data.map(el => {
                        // Identifica il tipo di sensore (DispenserSubtype)
                        const sensorSubtype = el.DispenserSubtype || null;
                        
                        // Calcola dati washroom se presenti, applicando aggiustamento Door Counter
                        const rawPartialCount = Number(el.PartialCount) || 0;
                        const partialCount = this.applyDoorCounterAdjustment(rawPartialCount, sensorSubtype);
                        const rawAlertValue = Number(el.AlertValue) || 0;
                        const alertValue = this.applyDoorCounterAdjustment(rawAlertValue, sensorSubtype);
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        let cleaningStatusColor = 'gray';
                        let cleaningStatus = '';
                        
                        if (el.DispenserType === 'Washroom' && alertValue > 0) {
                            if (perc >= 100) {
                                cleaningStatusColor = "red";
                                cleaningStatus = "Cleaning Required";
                            } else if (perc > 25) {
                                cleaningStatusColor = "#ffac27";
                                cleaningStatus = "Might need clean";
                            } else {
                                cleaningStatusColor = "green";
                                cleaningStatus = "Doesn't need clean";
                            }
                        }
                        
                        // Off/online da percentuale = -1 (senza chiamata GET_DATA_FROM_DYNAMO)
                        const isOffByPercent = Number(el.percentuale) === -1;
                        
                        // Per i dispenser, usa la soglia di alert (AlertValue)
                        const dispenserAlertThreshold = Number(el.AlertValue) || 0;
                        
                        // Per i sensori Air e Washroom, costruisci l'URL completo da S3
                        let dispenserImage = el.DispenserImage;
                        if (el.DispenserType === 'Air' || el.DispenserType === 'Washroom') {
                            console.log('Air/Washroom sensor detected:', {
                                sensorName: el.DisplayName,
                                dispenserImage: el.DispenserImage,
                                dispenserType: el.DispenserType
                            });
                            
                            if (el.DispenserImage) {
                                // Verifica se DispenserImage è già un URL completo o solo il nome del file
                                if (!el.DispenserImage.startsWith('http')) {
                                    dispenserImage = this.$store.state.URL_IMAGES_S3 + el.DispenserImage;
                                    console.log('✅ Constructed S3 URL:', dispenserImage);
                                } else {
                                    console.log('✅ Image is already a full URL:', dispenserImage);
                                }
                            } else {
                                console.warn('⚠️ DispenserImage is empty for sensor:', el.DisplayName);
                            }
                        }
                        
                        const mappedItem = {
                            stato: isOffByPercent && el.DispenserType == 'Dispenser' ? 'gray' : (el.DispenserType == 'Dispenser' ? this.calculateDispenserStatus(el.percentuale, dispenserAlertThreshold) : ''),
                            DispenserType: dispenserImage,
                            percentuale: el.DispenserType == 'Dispenser' ? el.percentuale : '',
                            name: el.DisplayName,
                            Company: el.CompanyName,
                            BuildingName: el.BuildingName,
                            floor: el.FloorName,
                            status: isOffByPercent ? 'off' : (el.DispenserType == 'Dispenser' || (el.DispenserType === 'Washroom' && alertValue > 0) ? 'on' : 'off'),
                            battery: el.BatteryLevel,
                            Area: el.AreaName,
                            sensorId: el.DispenserUnique,
                            id: el.id,
                            liveUsage: partialCount,
                            cleaningLimit: alertValue > 0 ? alertValue : '-',
                            cleaningStatus: cleaningStatus,
                            cleaningStatusColor: isOffByPercent && el.DispenserType === 'Washroom' ? 'gray' : cleaningStatusColor,
                            sensorSubtype: sensorSubtype, // Salva il tipo di sensore per uso successivo
                            dispenserSubtype: sensorSubtype, // Anche come dispenserSubtype per la visualizzazione
                            // Aggiungi gli ID necessari per la navigazione
                            companyId: el.CompanyId,
                            buildingId: el.BuildingId,
                            floorId: el.FloorId,
                            areaId: el.AreaId
                        };
                        
                        // Log per verificare che l'URL sia assegnato correttamente
                        if (el.DispenserType === 'Air' || el.DispenserType === 'Washroom') {
                            console.log('📦 Final mapped item for Air/Washroom sensor:', {
                                name: mappedItem.name,
                                DispenserType: mappedItem.DispenserType,
                                imageLength: mappedItem.DispenserType ? mappedItem.DispenserType.length : 0
                            });
                        }
                        
                        return mappedItem;
                    });

                    this.items = baseItems;

                    // this.items_all = this.items;
                    // this.filterBuilding_items = this.items.map(item => ({
                    //     text: item.BuildingName,
                    //     value: item.BuildingName
                    // }));
                    // this.filterBuilding_items.push({ text: "ALL", value: "ALL" });
                    // this.DownloadCompanyDatas();
                    // this.GetDispenserTypes();
                    if (!skipOverlay) {
                        this.overlay = false;
                    }
                })
        },
        LoadComponentData() {
            axios.post(this.$store.state.URL_GET_DISPENSER_BRAND)
                .then(res => {
                    res.data.forEach(el => {
                        var element = { text: el.DispenserBrandame, value: el.id }
                        this.dispenserBrands.push(element);
                    })
                    axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.CompanyName, value: el.id }
                                this.clients.push(element);

                            })
                            axios.post(this.$store.state.URL_GET_CONSUMABLE_BRANDS)
                                .then(res => {
                                    res.data.forEach(el => {
                                        var element = { text: el.Brand, value: el.id }
                                        this.consumableBrands.push(element);
                                    })
                                    this.overlay = false;
                                    this.dialogAdd = true;
                                })
                                .catch(() => {
                                    this.overlay = false;
                                })
                        })
                        .catch(() => {
                            this.overlay = false;
                        })
                })
                .catch(() => {
                    this.overlay = false;
                });
        },
        GetDispenserTypes() {
            this.sensorTypes.length = 0;
            axios.post(this.$store.state.URL_DISPENSERTYPE, {
                "company": this.$store.state.company
            })
                .then(res => {
                    if (res.data.length > 0) {
                        res.data.forEach(el => {
                            this.sensorTypes.push({ text: el.DispenserTypeName, value: el });
                        })
                    }
                    //else {
                    //    this.addButton = false;
                    //}
                })
        },
        DownloadCompanyDatas() {
            axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
                .then(res => {
                    res.data.forEach(el => {
                        var element = { text: el.CompanyName, value: el.id }
                        this.filterClients.push(element);

                    })
                })
                .catch(() => {
                    this.overlay = false;
                    this.$router.push({ path: "/" });
                })
            axios.post(this.$store.state.URL_COMPANY_DATA, {
                "Company": this.$store.state.company
            })
                .then(res => {
                    this.$store.state.building = res.data
                    this.building_items.length = 0;
                    this.floor_items.length = 0;

                    this.$store.state.building.buildings.forEach(el => {
                        var found = false;
                        var c = 0;
                        el.floors.forEach(e => {
                            e.sensors.forEach(s => {
                                found = Object.values(s).includes("Dispenser")
                                if (found)
                                    c++;
                                console.log(e, found)
                            })

                        })

                        if (c > 0) {
                            if (this.$store.state.company == '1')
                                this.building_items.push({ text: el.BuildingName.replace('Zwetko Headquarter', 'Airport'), value: el });
                            else
                                this.building_items.push({ text: el.BuildingName, value: el });
                        }
                    })
                })
                .catch(() => {
                    //Redirect alla pagina di errore
                    //this.snackbar = true;
                })
        },
        CheckInvio(evt) {
            if (evt != null && evt != undefined) {

                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (charCode === 13) {
                    this.Login();
                }
            }
        },
        async GetSensorsData() {
            this.overlay = true;
            axios
                .post(`${this.$store.state.URL_SENSORSMANAGEMENT}`,
                    { id_company: this.$store.state.company, 'type': this.$route.params.type })
                .then(async res => {
                    const baseItems = res.data.map(el => {
                        // Identifica il tipo di sensore (DispenserSubtype)
                        const sensorSubtype = el.DispenserSubtype || null;
                        
                        // Calcola dati washroom se presenti, applicando aggiustamento Door Counter
                        const rawPartialCount = Number(el.PartialCount) || 0;
                        const partialCount = this.applyDoorCounterAdjustment(rawPartialCount, sensorSubtype);
                        const rawAlertValue = Number(el.AlertValue) || 0;
                        const alertValue = this.applyDoorCounterAdjustment(rawAlertValue, sensorSubtype);
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        let cleaningStatusColor = 'gray';
                        let cleaningStatus = '';
                        
                        if (el.DispenserType === 'Washroom' && alertValue > 0) {
                            if (perc >= 100) {
                                cleaningStatusColor = "red";
                                cleaningStatus = "Cleaning Required";
                            } else if (perc > 25) {
                                cleaningStatusColor = "#ffac27";
                                cleaningStatus = "Might need clean";
                            } else {
                                cleaningStatusColor = "green";
                                cleaningStatus = "Doesn't need clean";
                            }
                        }
                        
                        // Off/online da percentuale = -1 (senza chiamata GET_DATA_FROM_DYNAMO)
                        const isOffByPercent = Number(el.percentuale) === -1;
                        
                        // Per i dispenser, usa la soglia di alert (AlertValue)
                        const dispenserAlertThreshold = Number(el.AlertValue) || 0;
                        
                        // Per i sensori Air e Washroom, costruisci l'URL completo da S3
                        let dispenserImage = el.DispenserImage;
                        if (el.DispenserType === 'Air' || el.DispenserType === 'Washroom') {
                            console.log('Air/Washroom sensor detected:', {
                                sensorName: el.DisplayName,
                                dispenserImage: el.DispenserImage,
                                dispenserType: el.DispenserType
                            });
                            
                            if (el.DispenserImage) {
                                // Verifica se DispenserImage è già un URL completo o solo il nome del file
                                if (!el.DispenserImage.startsWith('http')) {
                                    dispenserImage = this.$store.state.URL_IMAGES_S3 + el.DispenserImage;
                                    console.log('✅ Constructed S3 URL:', dispenserImage);
                                } else {
                                    console.log('✅ Image is already a full URL:', dispenserImage);
                                }
                            } else {
                                console.warn('⚠️ DispenserImage is empty for sensor:', el.DisplayName);
                            }
                        }
                        
                        const mappedItem = {
                            stato: isOffByPercent && el.DispenserType == 'Dispenser' ? 'gray' : (el.DispenserType == 'Dispenser' ? this.calculateDispenserStatus(el.percentuale, dispenserAlertThreshold) : ''),
                            DispenserType: dispenserImage,
                            percentuale: el.DispenserType == 'Dispenser' ? el.percentuale : '',
                            name: el.DisplayName,
                            Company: el.CompanyName,
                            BuildingName: el.BuildingName,
                            floor: el.FloorName,
                            status: isOffByPercent ? 'off' : (el.DispenserType == 'Dispenser' || (el.DispenserType === 'Washroom' && alertValue > 0) ? 'on' : 'off'),
                            battery: el.BatteryLevel,
                            Area: el.AreaName,
                            sensorId: el.DispenserUnique,
                            id: el.id,
                            liveUsage: partialCount,
                            cleaningLimit: alertValue > 0 ? alertValue : '-',
                            cleaningStatus: cleaningStatus,
                            cleaningStatusColor: isOffByPercent && el.DispenserType === 'Washroom' ? 'gray' : cleaningStatusColor,
                            sensorSubtype: sensorSubtype, // Salva il tipo di sensore per uso successivo
                            dispenserSubtype: sensorSubtype, // Anche come dispenserSubtype per la visualizzazione
                            // Aggiungi gli ID necessari per la navigazione
                            companyId: el.CompanyId,
                            buildingId: el.BuildingId,
                            floorId: el.FloorId,
                            areaId: el.AreaId
                        };
                        
                        // Log per verificare che l'URL sia assegnato correttamente
                        if (el.DispenserType === 'Air' || el.DispenserType === 'Washroom') {
                            console.log('📦 Final mapped item for Air/Washroom sensor:', {
                                name: mappedItem.name,
                                DispenserType: mappedItem.DispenserType,
                                imageLength: mappedItem.DispenserType ? mappedItem.DispenserType.length : 0
                            });
                        }
                        
                        return mappedItem;
                    });

                    this.items = baseItems;
                    this.items_all = this.items;
                    this.filterBuilding_items = this.items.map(item => ({
                        text: item.BuildingName,
                        value: item.BuildingName
                    }));
                    this.filterBuilding_items.push({ text: "ALL", value: "ALL" });

                    this.DownloadCompanyDatas();
                    this.GetDispenserTypes();
                    this.overlay = false;
                })
                .catch(error => {
                    console.error('Error fetching sensor data:', error);
                    this.overlay = false; // Ensure overlay is removed even if there's an error
                });
        },
        editSensor(item) {
            this.editingSensorId = item.id;
            this.editingSensorName = item.name;
            this.overlay = true;
            this.isLoadingEditData = true; // Disabilita i watcher durante il caricamento
            
            // Imposta subito il tipo button dall'item già mappato nella lista
            if (this.isButtonPage) {
                const subtype = item.dispenserSubtype || '';
                this.buttonSubtype = subtype === 'RFID' ? 'RFID_BUTTON' : subtype;
            }
            
            // Chiudi completamente il dialog di aggiunta e reset del form per evitare conflitti
            this.dialogAdd = false;
            this.isDuplicating = false;
            this.duplicateSensorDialog = false;
            this.errorDialog = false;
            
            // Reset completo delle variabili del form di creazione PRIMA di popolare i dati di modifica
            this.devEui = '';
            this.dispenserName = '';
            this.dispenserBrand = '';
            this.dispenserArticleCode = '';
            this.consumableBrand = '';
            this.consumableArticleCode = '';
            this.client = '';
            this.buildingValue = '';
            this.floorValue = '';
            this.areaValue = '';
            this.maxValue = '';
            this.minValue = '';
            
            // Reset completo del form di creazione per evitare conflitti di validazione
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }
            });

            // Reset delle liste e visibilità
            this.dispenserBrands = [];
            this.dispenserArticleCodes = [];
            this.consumableBrands = [];
            this.consumableArticleCodes = [];
            this.clients = [];
            this.buildings = [];
            this.floors = [];
            this.areas = [];
            this.showDispenserArticleCode = false;
            this.showConsumableBrand = false;
            this.showConsumableArticleCode = false;
            this.showBuilding = false;
            this.showFloor = false;
            this.showArea = false;

            // Ottieni il token
            const token = localStorage.getItem("token");

            // Carica prima i dati di base (brands, clients)
            axios.post(this.$store.state.URL_GET_DISPENSER_BRAND)
                .then(res => {
                    res.data.forEach(el => {
                        this.dispenserBrands.push({ text: el.DispenserBrandame, value: el.id });
                    });
                    return axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT);
                })
                .then(res => {
                    res.data.forEach(el => {
                        this.clients.push({ text: el.CompanyName, value: el.id });
                    });
                    return axios.post(this.$store.state.URL_GET_CONSUMABLE_BRANDS);
                })
                .then(res => {
                    res.data.forEach(el => {
                        this.consumableBrands.push({ text: el.Brand, value: el.id });
                    });
                    // Ora ottieni i dettagli completi del sensore usando il nuovo endpoint
                    const url = this.$store.state.BASE_URL + this.$store.state.URL_NEW_GET_SENSOR_DETAILS.replace('{DispenserId}', item.id);
                    return axios.get(url, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                })
                .then(res => {
                    const sensorDetails = res.data;

                    // Log per debug - mostra tutti i campi
                    console.log('========== SENSOR DETAILS ==========');
                    console.log('Full sensor details:', sensorDetails);
                    console.log('All keys in sensorDetails:', Object.keys(sensorDetails));
                    console.log('====================================');

                    // Popola i campi con i dati esistenti
                    this.devEui = sensorDetails.DispenserUnique || item.sensorId;
                    this.dispenserName = sensorDetails.DisplayName || item.name;
                    this.client = sensorDetails.companyId ? parseInt(sensorDetails.companyId) : '';
                    
                    // buttonSubtype già impostato da item.dispenserSubtype all'apertura del dialog

                    // Carica i valori Max e Min
                    this.maxValue = sensorDetails.maxValue !== undefined && sensorDetails.maxValue !== null ? sensorDetails.maxValue : '';
                    this.minValue = sensorDetails.minValue !== undefined && sensorDetails.minValue !== null ? sensorDetails.minValue : '';
                    
                    console.log('Max Value:', this.maxValue);
                    console.log('Min Value:', this.minValue);

                    // Imposta il valore del brand e carica i dati correlati
                    this.dispenserBrand = sensorDetails.dispenserBrand ? parseInt(sensorDetails.dispenserBrand) : '';
                    
                    // Imposta il valore del brand consumabile
                    console.log('========== CONSUMABLE BRAND SETUP ==========');
                    console.log('Raw consumableBrandId from API:', sensorDetails.consumableBrandId);
                    
                    // Salva il valore in una variabile locale
                    const consumableBrandValue = sensorDetails.consumableBrandId ? parseInt(sensorDetails.consumableBrandId) : '';
                    
                    // Mostra la select PRIMA
                    this.showConsumableBrand = true;
                    
                    // Imposta il valore DOPO che Vue ha aggiornato il DOM usando $nextTick
                    this.$nextTick(() => {
                        this.consumableBrand = consumableBrandValue;
                        console.log('✅ Consumable Brand set to:', this.consumableBrand);
                        
                        // Verifica se il valore esiste nelle opzioni disponibili
                        if (this.consumableBrand) {
                            const brandExists = this.consumableBrands.find(b => b.value === this.consumableBrand);
                            console.log('Brand exists in options?', brandExists ? '✅ Yes' : '❌ No');
                        }
                    });
                    console.log('============================================');

                    // Chain delle promise per caricare i dati in sequenza
                    let promise = Promise.resolve();

                    // Carica dispenser article codes se c'è un brand
                    if (this.dispenserBrand) {
                        this.showDispenserArticleCode = true;
                        promise = promise.then(() => {
                            return axios.post(this.$store.state.URL_GET_DISPENSER_CODES, {
                                idDispenserBrand: this.dispenserBrand
                            }).then(res => {
                                this.dispenserArticleCodes = [];
                                res.data.forEach(el => {
                                    this.dispenserArticleCodes.push({
                                        text: el.ArticleCode + " - " + el.Description,
                                        value: el.id,
                                        dispenserSubtype: el.DispenserSubtype || el.dispenserSubtype || null
                                    });
                                });
                                // Imposta il valore selezionato
                                if (sensorDetails.dispenserModel) {
                                    this.dispenserArticleCode = parseInt(sensorDetails.dispenserModel);
                                }
                            }).then(() => {
                                // Carica consumable article codes dopo aver caricato dispenser article code
                                console.log('Checking consumable loading conditions:');
                                console.log('- consumableBrandValue:', consumableBrandValue);
                                console.log('- this.dispenserArticleCode:', this.dispenserArticleCode);
                                
                                if (consumableBrandValue && this.dispenserArticleCode) {
                                    this.showConsumableArticleCode = true;
                                    console.log('✅ Loading consumable article codes...');
                                    return axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                                        consumableBrand: consumableBrandValue,
                                        dispenserId: this.dispenserArticleCode
                                    }).then(res => {
                                        console.log('✅ Consumable article codes loaded:', res.data.length, 'items');
                                        this.consumableArticleCodes = [];
                                        res.data.forEach(el => {
                                            this.consumableArticleCodes.push({
                                                text: el.ArtcleCode + " - " + el.Name,
                                                value: el.id
                                            });
                                        });
                                        // Imposta il valore selezionato usando $nextTick
                                        if (sensorDetails.consumableArticleId) {
                                            const articleCodeValue = parseInt(sensorDetails.consumableArticleId);
                                            this.$nextTick(() => {
                                                this.consumableArticleCode = articleCodeValue;
                                                console.log('✅ Consumable article code set to:', this.consumableArticleCode);
                                            });
                                        }
                                    }).catch(error => {
                                        console.error('❌ Error loading consumable article codes:', error);
                                    });
                                } else {
                                    console.log('⏭️ Skipping consumable article codes - conditions not met');
                                    console.log('Missing:', !consumableBrandValue ? 'consumableBrand' : '', !this.dispenserArticleCode ? 'dispenserArticleCode' : '');
                                }
                            });
                        });
                    }

                    // Carica buildings se c'è un client
                    if (this.client) {
                        this.showBuilding = true;
                        promise = promise.then(() => {
                            return axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                                companyId: this.client
                            }).then(res => {
                                this.buildings = [];
                                res.data.forEach(el => {
                                    this.buildings.push({ text: el.BuildingName, value: el.id });
                                });
                                // Imposta il valore selezionato
                                if (sensorDetails.buildingId) {
                                    this.buildingValue = parseInt(sensorDetails.buildingId);
                                }
                            });
                        });

                        // Carica floors se c'è un building
                        if (sensorDetails.buildingId) {
                            promise = promise.then(() => {
                                this.showFloor = true;
                                return axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                                    buildingId: parseInt(sensorDetails.buildingId)
                                }).then(res => {
                                    this.floors = [];
                                    res.data.forEach(el => {
                                        this.floors.push({ text: el.FloorName, value: el.id });
                                    });
                                    // Imposta il valore selezionato
                                    if (sensorDetails.floorId) {
                                        this.floorValue = parseInt(sensorDetails.floorId);
                                    }
                                });
                            });

                            // Carica areas se c'è un floor
                            if (sensorDetails.floorId) {
                                promise = promise.then(() => {
                                    this.showArea = true;
                                    return axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                                        floorId: parseInt(sensorDetails.floorId)
                                    }).then(res => {
                                        this.areas = [];
                                        res.data.forEach(el => {
                                            this.areas.push({ text: el.AreaName, value: el.id });
                                        });
                                        // Imposta il valore selezionato
                                        if (sensorDetails.areaId) {
                                            this.areaValue = parseInt(sensorDetails.areaId);
                                        }
                                    });
                                });
                            }
                        }
                    }

                    // Quando tutte le promise sono completate, mostra il dialog
                    promise.then(() => {
                        this.overlay = false;
                        this.dialogEdit = true;
                        // Riabilita i watcher dopo che tutto è caricato
                        this.$nextTick(() => {
                            this.isLoadingEditData = false;
                            console.log('✅ Edit data loading complete - watchers re-enabled');
                        });
                    });
                })
                .catch(error => {
                    console.error('Error fetching sensor details:', error);
                    this.overlay = false;
                    this.isLoadingEditData = false; // Riabilita i watcher anche in caso di errore
                    // Mostra l'errore usando la dialog
                    this.showError(this.$t('sensor.error.loading'));
                });
        },

        // Metodi di supporto per caricare dati correlati in base alle selezioni
        loadDispenserArticleCodes(brandId, selectedCodeId = null) {
            this.showDispenserArticleCode = true;
            this.dispenserArticleCodes = [];
            this.dispenserArticleCode = '';

            axios.post(this.$store.state.URL_GET_DISPENSER_CODES, {
                idDispenserBrand: brandId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.dispenserArticleCodes.push({
                            text: el.ArticleCode + " - " + el.Description,
                            value: el.id,
                            dispenserSubtype: el.DispenserSubtype || el.dispenserSubtype || null
                        });
                    });

                    if (selectedCodeId) {
                        this.dispenserArticleCode = selectedCodeId;
                    }
                });
        },

        loadFloors(buildingId, selectedFloorId = null) {
            this.showFloor = true;
            this.floors = [];
            this.floorValue = '';

            axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                buildingId: buildingId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.floors.push({
                            text: el.FloorName,
                            value: el.id
                        });
                    });

                    if (selectedFloorId) {
                        this.floorValue = selectedFloorId;
                    }
                });
        },

        loadAreas(floorId, selectedAreaId = null) {
            this.showArea = true;
            this.areas = [];
            this.areaValue = '';

            axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                floorId: floorId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.areas.push({
                            text: el.AreaName,
                            value: el.id
                        });
                    });

                    if (selectedAreaId) {
                        this.areaValue = selectedAreaId;
                    }
                });
        },

        loadConsumableArticleCodes(brandId, dispenserId, selectedCodeId = null) {
            this.showConsumableArticleCode = true;
            this.consumableArticleCodes = [];
            this.consumableArticleCode = '';

            axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                consumableBrand: brandId,
                dispenserId: dispenserId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.consumableArticleCodes.push({
                            text: el.ArtcleCode + " - " + el.Name,
                            value: el.id
                        });
                    });

                    if (selectedCodeId) {
                        this.consumableArticleCode = selectedCodeId;
                    }
                });
        },

        closeEditDialog() {
            this.dialogEdit = false;
            this.duplicateSensorDialog = false;
            this.errorDialog = false;
            this.isLoadingEditData = false;
            this.buttonSubtype = '';
            
            // Reset delle variabili per evitare conflitti futuri
            this.editingSensorId = null;
            this.editingSensorName = '';
        },
        
        closeAddDialog() {
            // Chiudi tutti i dialog
            this.dialogAdd = false;
            this.isDuplicating = false;
            this.duplicateSensorDialog = false;
            this.errorDialog = false;
            
            // Reset completo del form di creazione
            this.devEui = '';
            this.dispenserName = '';
            this.dispenserBrand = '';
            this.dispenserArticleCode = '';
            this.consumableBrand = '';
            this.consumableArticleCode = '';
            this.client = '';
            this.buildingValue = '';
            this.floorValue = '';
            this.areaValue = '';
            this.maxValue = '';
            this.minValue = '';
            this.buttonSubtype = '';
            
            // Reset delle liste
            this.dispenserArticleCodes = [];
            this.consumableArticleCodes = [];
            this.buildings = [];
            this.floors = [];
            this.areas = [];
            
            // Reset delle visibilità
            this.showDispenserArticleCode = false;
            this.showConsumableBrand = false;
            this.showConsumableArticleCode = false;
            this.showBuilding = false;
            this.showFloor = false;
            this.showArea = false;
            
            // Reset della validazione del form - usa setTimeout per assicurare che il reset avvenga dopo la chiusura del dialog
            setTimeout(() => {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }
            }, 100);
        },
        
        duplicateSensor(item) {
            this.overlay = true;
            this.isDuplicating = true; // Imposta flag per mostrare il titolo corretto
            
            // Chiudi eventuali dialog aperti
            this.dialogEdit = false;
            this.duplicateSensorDialog = false;
            this.errorDialog = false;
            
            // Reset del form di creazione
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            // Reset delle liste e visibilità
            this.dispenserBrands = [];
            this.dispenserArticleCodes = [];
            this.consumableBrands = [];
            this.consumableArticleCodes = [];
            this.clients = [];
            this.buildings = [];
            this.floors = [];
            this.areas = [];
            this.showDispenserArticleCode = false;
            this.showConsumableBrand = false;
            this.showConsumableArticleCode = false;
            this.showBuilding = false;
            this.showFloor = false;
            this.showArea = false;

            // Ottieni il token
            const token = localStorage.getItem("token");

            // Carica prima i dati di base (brands, clients)
            axios.post(this.$store.state.URL_GET_DISPENSER_BRAND)
                .then(res => {
                    res.data.forEach(el => {
                        this.dispenserBrands.push({ text: el.DispenserBrandame, value: el.id });
                    });
                    return axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT);
                })
                .then(res => {
                    res.data.forEach(el => {
                        this.clients.push({ text: el.CompanyName, value: el.id });
                    });
                    return axios.post(this.$store.state.URL_GET_CONSUMABLE_BRANDS);
                })
                .then(res => {
                    res.data.forEach(el => {
                        this.consumableBrands.push({ text: el.Brand, value: el.id });
                    });
                    // Ottieni i dettagli completi del sensore da duplicare
                    const url = this.$store.state.BASE_URL + this.$store.state.URL_NEW_GET_SENSOR_DETAILS.replace('{DispenserId}', item.id);
                    return axios.get(url, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                })
                .then(res => {
                    const sensorDetails = res.data;

                    console.log('Duplicating sensor with details:', sensorDetails);

                    // Popola i campi con i dati esistenti TRANNE il devEui (ID)
                    this.devEui = ''; // RESET - l'utente dovrà inserire un nuovo ID
                    this.dispenserName = sensorDetails.DisplayName || item.name;
                    this.client = sensorDetails.companyId ? parseInt(sensorDetails.companyId) : '';
                    
                    // Carica i valori Max e Min
                    this.maxValue = sensorDetails.maxValue !== undefined && sensorDetails.maxValue !== null ? sensorDetails.maxValue : '';
                    this.minValue = sensorDetails.minValue !== undefined && sensorDetails.minValue !== null ? sensorDetails.minValue : '';

                    // Imposta il valore del brand
                    this.dispenserBrand = sensorDetails.dispenserBrand ? parseInt(sensorDetails.dispenserBrand) : '';
                    
                    // Mostra la select del consumable brand PRIMA di impostare il valore
                    this.showConsumableBrand = true;

                    // Carica buildings
                    return axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                        companyId: this.client
                    }).then(buildingsRes => {
                        buildingsRes.data.forEach(el => {
                            this.buildings.push({ text: el.BuildingName, value: el.id });
                        });
                        
                        this.showBuilding = true;
                        this.buildingValue = sensorDetails.buildingId ? parseInt(sensorDetails.buildingId) : '';
                        
                        // Ritorna sensorDetails per usarlo più avanti
                        return { sensorDetails, floorsPromise: sensorDetails.buildingId ? 
                            axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                                buildingId: sensorDetails.buildingId
                            }) : Promise.resolve({ data: [] })
                        };
                    });
                })
                .then(result => {
                    // Attendi il caricamento dei floors
                    return result.floorsPromise.then(floorsRes => {
                        return { sensorDetails: result.sensorDetails, floorsRes };
                    });
                })
                .then(result => {
                    const { sensorDetails, floorsRes } = result;
                    
                    if (floorsRes.data && floorsRes.data.length > 0) {
                        floorsRes.data.forEach(el => {
                            this.floors.push({ text: el.FloorName, value: el.id });
                        });
                        this.showFloor = true;
                        this.floorValue = sensorDetails.floorId ? parseInt(sensorDetails.floorId) : '';
                    }
                    
                    // Ritorna sensorDetails per continuare il flusso
                    return sensorDetails;
                })
                .then(sensorDetails => {
                    // Carica areas se esiste floorId
                    if (sensorDetails && sensorDetails.floorId) {
                        return axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                            floorId: sensorDetails.floorId
                        }).then(areasRes => {
                            if (areasRes.data && areasRes.data.length > 0) {
                                areasRes.data.forEach(el => {
                                    this.areas.push({ text: el.AreaName, value: el.id });
                                });
                                this.showArea = true;
                                this.areaValue = sensorDetails.areaId ? parseInt(sensorDetails.areaId) : '';
                            }
                            return sensorDetails;
                        });
                    }
                    return sensorDetails;
                })
                .then(sensorDetails => {
                    if (sensorDetails) {
                        // Carica dispenser article codes
                        if (sensorDetails.dispenserBrand) {
                            this.showDispenserArticleCode = true;
                            return axios.post(this.$store.state.URL_GET_DISPENSER_CODES, {
                                idDispenserBrand: sensorDetails.dispenserBrand
                            }).then(codesRes => {
                                if (codesRes.data && codesRes.data.length > 0) {
                                    codesRes.data.forEach(el => {
                                        this.dispenserArticleCodes.push({
                                            text: el.ArticleCode + " - " + el.Description,
                                            value: el.id,
                                            dispenserSubtype: el.DispenserSubtype || el.dispenserSubtype || null
                                        });
                                    });
                                    
                                    const dispenserModelFromAPI = sensorDetails.dispenserModel;
                                    const matchingOption = this.dispenserArticleCodes.find(option => 
                                        option.value == dispenserModelFromAPI || 
                                        option.value === parseInt(dispenserModelFromAPI)
                                    );
                                    
                                    if (matchingOption) {
                                        this.dispenserArticleCode = matchingOption.value;
                                    }
                                }
                                return sensorDetails;
                            });
                        }
                    }
                    return sensorDetails;
                })
                .then(sensorDetails => {
                    if (sensorDetails) {
                        // Carica consumable article codes
                        const consumableBrandId = sensorDetails.consumableBrandId;
                        const dispenserArticleCodeId = sensorDetails.dispenserModel;
                        
                        if (consumableBrandId && dispenserArticleCodeId) {
                            this.showConsumableArticleCode = true;
                            return axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                                consumableBrand: consumableBrandId,
                                dispenserId: dispenserArticleCodeId
                            }).then(consumableRes => {
                                if (consumableRes.data && consumableRes.data.length > 0) {
                                    consumableRes.data.forEach(el => {
                                        this.consumableArticleCodes.push({
                                            text: el.ArtcleCode + " - " + el.Name,
                                            value: el.id
                                        });
                                    });
                                    
                                    // NON impostiamo il valore qui - lo faremo dopo che il dialog è aperto
                                }
                                return sensorDetails; // Ritorna sensorDetails per usarlo nel prossimo then
                            });
                        }
                    }
                    return sensorDetails;
                })
                .then((sensorDetails) => {
                    // Apri il dialog di CREAZIONE (non quello di modifica)
                    this.overlay = false;
                    this.dialogAdd = true;
                    
                    // Imposta consumable brand e article code DOPO che il dialog è aperto e il DOM è aggiornato
                    if (sensorDetails) {
                        console.log('=== DEBUG DUPLICATE - Sensor Details ===');
                        console.log('consumableBrandId:', sensorDetails.consumableBrandId);
                        console.log('consumableArticleId:', sensorDetails.consumableArticleId);
                        console.log('consumableArticleCodes disponibili:', this.consumableArticleCodes);
                        
                        // Usa setTimeout per dare più tempo al DOM di renderizzare
                        setTimeout(() => {
                            // Imposta il consumable brand
                            if (sensorDetails.consumableBrandId) {
                                const consumableBrandValue = parseInt(sensorDetails.consumableBrandId);
                                this.consumableBrand = consumableBrandValue;
                                console.log('✓ Consumable Brand impostato a:', this.consumableBrand);
                            }
                            
                            // Aspetta che il consumable brand sia completamente settato prima di impostare l'article code
                            setTimeout(() => {
                                // Imposta il consumable article code
                                if (sensorDetails.consumableArticleId && this.consumableArticleCodes.length > 0) {
                                    const consumableArticleCodeFromAPI = sensorDetails.consumableArticleId;
                                    console.log('Cercando consumable article code:', consumableArticleCodeFromAPI);
                                    console.log('Tipo:', typeof consumableArticleCodeFromAPI);
                                    
                                    const matchingConsumableOption = this.consumableArticleCodes.find(option => {
                                        const matches = option.value == consumableArticleCodeFromAPI || 
                                                       option.value === parseInt(consumableArticleCodeFromAPI);
                                        console.log(`Confronto ${option.value} (${typeof option.value}) con ${consumableArticleCodeFromAPI} (${typeof consumableArticleCodeFromAPI}): ${matches}`);
                                        return matches;
                                    });
                                    
                                    if (matchingConsumableOption) {
                                        this.consumableArticleCode = matchingConsumableOption.value;
                                        console.log('✓ Consumable Article Code impostato a:', this.consumableArticleCode);
                                    } else {
                                        console.warn('✗ Consumable Article Code NON trovato:', consumableArticleCodeFromAPI);
                                        console.warn('Valori disponibili:', this.consumableArticleCodes.map(c => c.value));
                                    }
                                } else {
                                    console.warn('✗ Impossibile impostare consumable article code');
                                    console.warn('consumableArticleId:', sensorDetails.consumableArticleId);
                                    console.warn('consumableArticleCodes.length:', this.consumableArticleCodes.length);
                                }
                            }, 200); // Aspetta 200ms prima di impostare l'article code
                        }, 100); // Aspetta 100ms dopo l'apertura del dialog
                    }
                    
                    console.log('Dialog di duplicazione aperto con tutti i campi precompilati tranne devEui');
                })
                .catch(error => {
                    console.error('Errore durante la duplicazione del sensore:', error);
                    this.overlay = false;
                    this.showError(this.$t('sensor.error.loadingData') || 'Errore nel caricamento dei dati');
                });
        },
        
        UpdateSensor() {
            // Chiudi eventuali dialog di errore aperti
            this.duplicateSensorDialog = false;
            this.errorDialog = false;
            
            if (!this.dispenserName || !this.client || !this.buildingValue || !this.floorValue || !this.areaValue) {
                this.showError(this.$t('sensor.error.requiredFields'));
                return;
            }

            this.overlay = true;

            // Ottieni il token
            const token = localStorage.getItem("token");
            
            // Costruisci l'URL sostituendo {DispenserId} con l'id del sensore
            const url = this.$store.state.BASE_URL + this.$store.state.URL_NEW_UPDATE_SENSOR.replace('{DispenserId}', this.editingSensorId);

            // Prepara il payload — struttura identica per button e dispenser
            const isButton = this.isButtonPage;
            const payload = {
                companyId: this.client,
                displayName: this.dispenserName,
                floorId: this.floorValue,
                areaId: this.areaValue,
                buildingId: this.buildingValue,
                dispenserModel: isButton ? '-' : (this.dispenserArticleCode ? this.dispenserArticleCode.toString() : null),
                dispenserBrand: isButton ? '-' : (this.dispenserBrand ? this.dispenserBrand.toString() : null),
                consumableBrandId: isButton ? '-' : (this.consumableBrand || null),
                consumableArticleId: isButton ? '-' : (this.consumableArticleCode || null),
                maxValue: isButton ? 0 : (this.maxValue !== '' && this.maxValue !== null && this.maxValue !== undefined ? parseFloat(this.maxValue) : 0),
                minValue: isButton ? 0 : (this.minValue !== '' && this.minValue !== null && this.minValue !== undefined ? parseFloat(this.minValue) : 0),
                dispenserSubtype: isButton
                    ? (this.buttonSubtype === 'RFID_BUTTON' ? 'RFID' : this.buttonSubtype)
                    : (this.selectedDispenserSubtype || null),
                sensorType: isButton
                    ? (this.buttonSubtype === 'RFID_BUTTON' ? 'RFID_BUTTON' : 'button')
                    : undefined,
            };

            console.log('Sending update payload:', payload);

            axios.put(url, payload, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(res => {
                    if (res.data.message === "Sensor updated successfully" || res.status === 200) {
                        this.dialogEdit = false;
                        // Mantieni l'overlay attivo durante il ricaricamento della lista
                        // Passa skipOverlay=true per evitare che Filter gestisca l'overlay
                        return this.Filter(true).then(() => {
                            this.overlay = false;
                        }).catch(error => {
                            console.error('Error reloading list:', error);
                            this.overlay = false;
                        });
                    } else {
                        this.showError(this.$t('sensor.error.updating'));
                        this.overlay = false;
                    }
                })
                .catch(error => {
                    console.error('Error updating sensor:', error);
                    this.showError(this.$t('sensor.error.updating'));
                    this.overlay = false;
                });
        },
        showError(message) {
            this.errorMessage = message;
            this.errorDialog = true;
        },
        handleDuplicateSensorError() {
            this.duplicateSensorDialog = false;
            
            // Reset del campo devEui per forzare l'utente a inserire un nuovo ID
            this.devEui = '';
            
            // Invalida il form per impedire il salvataggio
            if (this.$refs.form) {
                this.$refs.form.validate();
            }
            
            // Focus sul campo Sensor ID
            this.$nextTick(() => {
                const sensorIdField = this.$el.querySelector('input[type="text"]');
                if (sensorIdField) {
                    sensorIdField.focus();
                    sensorIdField.select();
                }
            });
        },
        navigateToSmartDispenser(item) {
            const routeName = 'SmartDispenser';
            this.$router.push({
                name: routeName,
                params: {
                    id: item.id,
                    sensorId: item.sensorId,
                    company: item.Company,
                    building: item.BuildingName,
                    floor: item.floor,
                    area: item.Area
                }
            });
        },
        navigateToSmartCleaning(item) {
            if (this.$route.params.type === 'washroom') {
                const routeName = 'WashroomFrequencyView'; // punta sempre alla V2
                this.$router.push({
                    name: routeName,
                    params: {
                        company: item.companyId,
                        building: item.buildingId,
                        floor: item.floorId,
                        area: item.areaId,
                        sensorId: item.id,
                        id: item.id
                    }
                });
            }
        },
        navigateToCleaningLog(item) {
            this.$router.push({
                name: 'CleaningLogView',
                params: {
                    sensorName:   item.name,
                    sensorId:     item.sensorId,
                    buildingName: item.BuildingName,
                    floorName:    item.floor,
                    areaName:     item.Area,
                }
            });
        },
        navigateToCleaningEfficiency(item) {
            this.$router.push({
                name: 'CleaningEfficiencyView',
                params: {
                    company:      item.companyId,
                    building:     item.buildingId,
                    buildingName: item.BuildingName,
                    floor:        item.floorId,
                    floorName:    item.floor,
                    area:         item.areaId,
                    areaName:     item.Area,
                }
            });
        },
        navigateToAirQuality(item) {
            console.log('Navigating to Air Quality with item:', item);
            if (this.$route.params.type === 'air') {
                this.$router.push({
                    name: 'AirQualityView',
                    params: {
                        company: item.companyId,
                        building: item.buildingId,
                        floor: item.floorId,
                        area: item.areaId,
                        sensorId: item.id,
                        id: item.id
                    }
                });
            }
        },
        handleImageError(event, item) {
            console.error('❌ Failed to load image for sensor:', {
                sensorName: item.name,
                imageUrl: event.target.src,
                sensorType: this.$route.params.type
            });
            
            // Imposta un'immagine placeholder o un'icona di default
            // event.target.src = 'path/to/placeholder.png'; // opzionale
            event.target.style.display = 'none'; // Nascondi l'immagine se fallisce
        }
    },
    watch: {
        '$route.params.type': function (type) {
            console.log(type)
            var typologies = ['dispenser', 'washroom', 'button', 'air'];
            if (typologies.includes(type)) {
                this.GetSensorsData();
            }
        },
        client(value) {
            // Non eseguire se stiamo caricando i dati di modifica
            if (this.isLoadingEditData) {
                console.log('⏭️ Skipping client watcher - loading edit data');
                return;
            }
            
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = false;
                this.showArea = false;
                this.floors.length = 0;
                this.areas.length = 0;
                this.showBuilding = true;
                this.buildings.length = 0;
                this.buildingValue = '';

                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.buildings.push(element);

                        });
                    })
            }
            else {
                this.showBuilding = false;
                this.buildings.length = 0;
                this.buildingValue = '';
            }
        },
        buildingValue(value) {
            // Non eseguire se stiamo caricando i dati di modifica
            if (this.isLoadingEditData) {
                console.log('⏭️ Skipping buildingValue watcher - loading edit data');
                return;
            }
            
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = true;
                this.floors.length = 0;
                this.floorValue = '';
                this.floors = [];
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.floors.push(element);
                        });

                    })
            }
            else {
                this.showFloor = false;
                this.floors.length = 0;
                this.floorValue = '';
            }
        },
        filterBuildingValue(value) {
            if (value == "ALL") {
                this.items = this.items_all;
            }
            else {
                this.items = this.items_all.filter(p => p.BuildingName == value);
            }
        },
        floorValue(value) {
            // Non eseguire se stiamo caricando i dati di modifica
            if (this.isLoadingEditData) {
                console.log('⏭️ Skipping floorValue watcher - loading edit data');
                return;
            }
            
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showArea = true;
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.areas.push(element);
                        });

                    })
            }

        },
        dispenserBrand(value) {
            // Non eseguire se stiamo caricando i dati di modifica
            if (this.isLoadingEditData) {
                console.log('⏭️ Skipping dispenserBrand watcher - loading edit data');
                return;
            }
            
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showDispenserArticleCode = true;
                this.dispenserArticleCodes.length = 0;
                this.dispenserArticleCode = '';
                this.consumableArticleCode = '';
                this.consumableArticleCodes.length = 0;
                axios.post(this.$store.state.URL_GET_DISPENSER_CODES, {
                    idDispenserBrand: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.ArticleCode + " - " + el.Description, value: el.id, dispenserSubtype: el.DispenserSubtype || el.dispenserSubtype || null };
                            this.dispenserArticleCodes.push(element);
                        });

                    })
            }
        },
        dispenserArticleCode(value) {
            // Non eseguire se stiamo caricando i dati di modifica
            if (this.isLoadingEditData) {
                console.log('⏭️ Skipping dispenserArticleCode watcher - loading edit data');
                return;
            }
            
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.consumableArticleCode = '';
                this.consumableArticleCodes.length = 0;
                this.showConsumableBrand = true;
                this.consumableBrands = [];
                this.consumableBrands.length = 0;
                this.consumableBrand = '';
                axios.post(this.$store.state.URL_GET_CONSUMABLE_BRANDS)
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.Brand, value: el.id }
                            this.consumableBrands.push(element);
                        })
                    })
            }
        },
        consumableBrand(value) {
            // Non eseguire se stiamo caricando i dati di modifica
            if (this.isLoadingEditData) {
                console.log('⏭️ Skipping consumableBrand watcher - loading edit data');
                return;
            }
            
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showConsumableArticleCode = true;
                this.consumableArticleCodes.length = 0;
                this.consumableArticleCode = '';
                axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                    consumableBrand: value,
                    dispenserId: this.dispenserArticleCode
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.ArtcleCode + " - " + el.Name, value: el.id }
                            this.consumableArticleCodes.push(element);
                        });

                    })
            }
        },
        Tipologiasensore(value) {
            this.sheetsVisible = false;
            if (value.DispenserPaperType == 'Foglietti') {
                this.sheetsVisible = true;
            }
            console.log(value)
        },
        filterClient(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = []
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildins = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterBuildings.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.filterBuildings.push(element);

                        });
                        // Applica automaticamente il filtro
                        this.Filter();
                    })
            }
            else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = []
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildins = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.Filter();
            }
        },
        filterBuilding(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterFloors.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.filterFloors.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.Filter();
                    })
            } else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.Filter();
            }
        },
        filterFloor(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterAreas = [];
                this.filterArea = '';
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterAreas.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.filterAreas.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.Filter();
                    })
            }
            else {
                this.filterAreas.length = 0;
                this.filterAreas = [];
                this.filterArea = '';
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.Filter();
            }
        },
        filterArea(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterSensors.push(el);
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.filterClient,
                    buildingId: this.filterBuilding,
                    floorId: this.filterFloor,
                    areaId: value,
                    type: this.$route.params.type
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DispenserUnique, value: el.id }
                            this.filterSensors.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.Filter();
                    })
            }
            else {
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.Filter();
            }
        },
        filterSensor(value) {
            // Applica automaticamente il filtro quando viene selezionato un sensore
            if (value !== undefined && value !== null) {
                this.Filter();
            }
        }
    },
    computed: {
        /** True se siamo nella pagina di gestione sensori Button (case-insensitive). */
        isButtonPage() {
            return this.$route.params.type?.toLowerCase() === 'button';
        },
        /** Opzioni per la select del tipo di sensore Button. */
        buttonSubtypeOptions() {
            return [
                { text: this.$t('manageSensors.buttonSubtypes.feedback'), value: 'feedback' },
                { text: this.$t('manageSensors.buttonSubtypes.click'), value: 'click' },
                { text: this.$t('manageSensors.buttonSubtypes.RFID_BUTTON'), value: 'RFID_BUTTON' },
            ];
        },
        /** DispenserSubtype del modello dispenser selezionato (per creazione nuovo sensore). */
        selectedDispenserSubtype() {
            const raw = this.dispenserArticleCode;
            if (raw == null || raw === '') return null;
            // Se per qualche motivo il v-model ha l'oggetto intero (es. prima di item-value)
            if (typeof raw === 'object' && raw !== null && 'dispenserSubtype' in raw) {
                return raw.dispenserSubtype || null;
            }
            const id = typeof raw === 'number' ? raw : parseInt(raw, 10);
            if (Number.isNaN(id)) return null;
            const option = this.dispenserArticleCodes.find(
                o => o.value == id || o.value === id
            );
            return option ? (option.dispenserSubtype || null) : null;
        },
        headers() {
            // Headers specifici per washroom
            if (this.$route.params.type === 'washroom') {
                return [
                    {},
                    { text: this.$t('manageSensors.type'), align: "center", value: "DispenserType" },
                    { text: this.$t('manageSensors.liveUsage'), align: "center", value: "liveUsage" },
                    { text: this.$t('manageSensors.cleaningLimit'), align: "center", value: "cleaningLimit" },
                    { text: this.$t('manageSensors.name'), align: "center", value: "name" },
                    { text: this.$t('manageSensors.company'), align: "center", value: "Company" },
                    { text: this.$t('manageSensors.building'), align: "center", value: "BuildingName" },
                    { text: this.$t('manageSensors.floor'), align: "center", value: "floor" },
                    { text: this.$t('manageSensors.area'), align: "center", value: "Area" },
                    { text: this.$t('manageSensors.battery'), align: "center", value: "Battery" },
                    { text: this.$t('manageSensors.sensorId'), align: "center", value: "sensorId" },
                    {},
                ];
            }
            
            // Headers per altri tipi (dispenser, etc.)
            return [{},
            { text: this.$t('manageSensors.type'), align: "center", value: "DispenserType" },
            { text: this.$t('manageSensors.fillLevel'), align: "center", value: "percentuale" },
            { text: this.$t('manageSensors.name'), align: "center", value: "name" },
            { text: this.$t('manageSensors.company'), align: "center", value: "Company" },
            { text: this.$t('manageSensors.building'), align: "center", value: "BuildingName" },
            { text: this.$t('manageSensors.floor'), align: "center", value: "floor" },
            { text: this.$t('manageSensors.area'), align: "center", value: "Area" },
            { text: this.$t('manageSensors.battery'), align: "center", value: "Battery" },
            { text: this.$t('manageSensors.sensorId'), align: "center", value: "sensorId" },
            {},
            ]
        },
        filteredHeaders() {
            return this.headers.filter(header => {
                if (header.text === this.$t('manageSensors.fillLevel')) {
                    return this.$route.params.type === 'dispenser';
                }
                return true;
            });
        }
    }
}
</script>